export default "__VITE_ASSET__6512c56f__"